export default "/images/b1ff0319d1533041270f5f9f3868641a.avif";